
/* injects from baggage-loader */

'use strict';

const moduleBlockOverlays = angular.module('services.layoutEditor.timemachine', []);

moduleBlockOverlays.factory('TimeMachine', [
    '$rootScope', '$timeout', '$injector', 'ns', 'TimeActs', ($rootScope, $timeout, $injector, ns, TimeActs) => {
        let Y = void 0;

        class TimeMachine {
            constructor() {
                this.maxStates = 10;
                this.history = [];
                this.forwardHistory = [];
            }

            init(y) {
                Y = y;
                TimeActs.init(y);

                $(document).bind('keydown.timemachine', (e) => {
                    this._keydown(e);
                });
            }
            clear() {
                this.history = [];
                this.forwardHistory = [];
                this.setBtnStatus();
            }
            _keydown(e) {
                const textInput = $(e.target).attr('contenteditable');

                if (!textInput) {
                    const ctrlKey = e.ctrlKey || e.metaKey;
                    const historySize = this.history.length;
                    const forwardHistorySize = this.forwardHistory.length;
                    const YKey = e.charCode === 25 || e.keyCode === 89;
                    const Zkey = e.charCode === 25 || e.keyCode === 90;

                    if (ctrlKey && YKey) {
                        e.preventDefault();
                    }

                    if (historySize && ctrlKey && Zkey) {
                        e.preventDefault();
                        this.undo();
                    }

                    if (forwardHistorySize && ctrlKey && YKey) {
                        this.redo();
                    }
                }
            }
            undo() {
                const lastCapture = this.history.pop();

                log('undo ' + lastCapture.act);
                this.forwardHistory.push(lastCapture);
                this.setBtnStatus();
                TimeActs[lastCapture.act + 'Act'].undo(lastCapture);
            }
            redo() {
                const lastCapture = this.forwardHistory.pop();

                log('redo ' + lastCapture.act);
                this.history.push(lastCapture);
                this.setBtnStatus();
                TimeActs[lastCapture.act + 'Act'].redo(lastCapture);
            }
            capture(act, json, html, path) {
                if (this.history.length > this.maxStates) {
                    this.history.shift();
                }
                if (this.forwardHistory.length > 0) {
                    this.forwardHistory = [];
                }

                this.history.push({
                    act: act,
                    json: json,
                    html: html,
                    path: path
                });

                this.setBtnStatus();
            }

            setBtnStatus() {
                $rootScope.undoActive = this.history.length;
                $rootScope.redoActive = this.forwardHistory.length;
            }

            destroy() {
                this.history = [];
                this.forwardHistory = [];
                this.setBtnStatus();
                $(document).unbind('keydown.timemachine');
            }
        }

        return new TimeMachine();
    }
]);



// WEBPACK FOOTER //
// ./src/app/editor/services/layout_editor/timemachine/timemachine.js